import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  DbContact,
  DbDeliverableType,
  DbProject,
  HandlersDeliverableCreateRequest,
  HandlersDeliverableResponse,
} from '../../app/athenaApiGen';

// Enable UTC plugin
dayjs.extend(utc);

const deliverableColumns: GridColDef<HandlersDeliverableResponse>[] = [
  {
    field: 'deliverableTitle',
    headerName: 'Title',
    flex: 1,
    valueGetter: (param: string) => (param?.length > 1 ? param : '-'),
  },
  {
    field: 'deliverableType',
    headerName: 'Type',
    flex: 1,
    valueGetter: (row: DbDeliverableType) => row?.title ?? '-',
  },
  {
    field: 'project',
    headerName: 'Project',
    flex: 1,
    valueGetter: (row: DbProject) => row?.title ?? '-',
  },
  {
    field: 'author',
    headerName: 'Author',
    flex: 1,
    valueGetter: (row: DbContact) => row?.name ?? '-',
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    width: 120,
    type: 'dateTime',
    valueFormatter: (params) => {
      // Return a formatted string from the Date object
      return params
        ? dayjs(new Date(params)).utc().format('MM/DD/YYYY').toString()
        : '-';
    },
  },
  {
    field: 'dateSubmitted',
    headerName: 'Date Submitted',
    width: 120,
    type: 'dateTime',
    valueFormatter: (params) => {
      // Return a formatted string from the Date object
      return params
        ? dayjs(new Date(params)).utc().format('MM/DD/YYYY').toString()
        : '-';
    },
  },
];

const createEmptyDeliverable = (): HandlersDeliverableCreateRequest => ({
  locationId: '',
  deliverableTypeId: '',
  deliverableTitle: '',
  workflowType: '',
  description: '',
  dueDate: dayjs().add(7, 'day').toString(),
  projectId: '',
});

export { deliverableColumns, createEmptyDeliverable };
